export {
  appleProvider,
  auth,
  getDb,
  googleProvider,
  microsoftProvider,
} from "@medly/auth-config/firebase/client";
